import React from 'react';
import { useParams, Link } from 'react-router-dom';
import './MobileBlogArticlePage.css';
import blogArticles from './blogArticles';

export default function MobileBlogArticlePage(){
  const { id } = useParams();
  const article = blogArticles[id];

  if(!article){
    return (
      <div className="mobile-article-page">
        <div className="mba-header"><Link to="/m/blog" className="mba-back-btn" aria-label="Back to blog">←</Link><h1 className="mba-title">Article not found</h1></div>
        <p className="mba-meta">We couldn't find the article you were looking for.</p>
        <Link to="/m/blog" className="mba-cta">Return to Blog</Link>
      </div>
    );
  }

  return (
    <div className="mobile-article-page">
      <header className="mba-header">
        <div className="mba-header-top">
          <Link to="/m/blog" className="mba-back-btn" aria-label="Back to blog">
            <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true"><path d="M13.8 5.2a1 1 0 0 1 0 1.4L9.4 11l4.4 4.4a1 1 0 1 1-1.4 1.4l-5.1-5.1a1 1 0 0 1 0-1.4l5.1-5.1a1 1 0 0 1 1.4 0Z" fill="currentColor"/></svg>
          </Link>
          <h1 className="mba-title">{article.title}</h1>
          <div className="mba-spacer" aria-hidden="true" />
        </div>
        <div className="mba-meta">{article.date}</div>
        <div className="mba-accent" />
      </header>
      <figure className="mba-hero">
        <img src={article.image} alt={article.title} onError={(e)=>{ e.currentTarget.onerror=null; e.currentTarget.src='/logos/blue_docuhounds_text.png'; }} />
      </figure>
      <article className="mba-content">
        {article.content.split('\n\n').map((para,i)=>(<p key={i}>{para}</p>))}
        <blockquote className="mba-quote">“Built from the ground up by Boston College founders with deep technical and operational experience.”</blockquote>
        <div className="mba-key-takeaway">
          <strong>Key Takeaway:</strong>
          <p>DocuHounds is a student-first academic platform that automates syllabus parsing, creates clear dashboards, and helps students regain time and focus.</p>
        </div>
      </article>
      <div className="mba-footer-cta">
        <Link to="/m/blog" className="mba-cta">← Back to Blog</Link>
      </div>
    </div>
  );
}